import { css } from 'aphrodite';
import * as React from 'react';
import { SuccessCheckIcon } from '../../../../web/components/svgs/icons/SuccessCheckIcon';
import { styleSheet } from '../styles';

interface IProps {
	availableLeadsLoading: boolean;
	availableLeadsNumber: number;
}

export const AvailableLeads: React.FC<IProps> = ({ availableLeadsLoading, availableLeadsNumber }) => {
	if (availableLeadsNumber === undefined) {
		return null;
	}

	const number = availableLeadsNumber <= 2000 ? availableLeadsNumber : '2000+';

	if (!availableLeadsLoading && availableLeadsNumber == null) {
		return null;
	}

	return (
		<div className={css(styleSheet.availableLeads)}>
			<SuccessCheckIcon size={16} />
			{availableLeadsLoading ? (
				<strong>Counting leads...</strong>
			) : (
				<span>
					<strong>Estimated available leads:</strong> {number}
				</span>
			)}
		</div>
	);
};
